module.exports = __webpack_public_path__ + "img/pasion.702fffd3.jpg";